import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ActivityMapping } from './activity-mapping';
export { ActivityMapping };
import { activityMappingSchema } from '@schemas/business-objects/activity-mapping';
import { TenantFormGroup } from './tenant-form-group';

export class ActivityMappingFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    designUuid: SchemaFormControl;
    sourceActivityId: SchemaFormControl;
    action: SchemaFormControl;
    targetActivityId: SchemaFormControl;
    minSourceVersion: SchemaFormControl;
    maxSourceVersion: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<ActivityMapping>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(activityMappingSchema, ActivityMapping, data, options);
  }

  get object(): ActivityMapping {
    return new ActivityMapping(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ActivityMapping[]> {
    return ActivityMapping.find(filter);
  }

  static async findOne(filter?: any): Promise<ActivityMapping | null> {
    return ActivityMapping.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<ActivityMapping> {
    return ActivityMapping.findById(id, filter);
  }

  static async create(
    data: Partial<ActivityMapping>,
  ): Promise<ActivityMapping> {
    return ActivityMapping.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ActivityMapping>,
  ): Promise<ActivityMapping> {
    return ActivityMapping.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ActivityMapping.deleteById(id);
  }
}

export class ActivityMappingFormArray extends PersistedFormArray {
  declare controls: ActivityMappingFormGroup[];

  readonly entityName = 'ActivityMapping' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(activityMappingSchema, ActivityMapping, options);
  }

  protected override createItemGroup() {
    return new ActivityMappingFormGroup();
  }

  get array(): ActivityMapping[] {
    return this.controls.map((group: ActivityMappingFormGroup) => group.object);
  }
}

export class ActivityMappingPersistedArray extends PersistedArray<ActivityMapping> {
  readonly entityName = 'ActivityMapping' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ActivityMapping, options);
  }
}
